<template>
  <div class="line-chart-wrapper" v-loading="pending">
    <div id="line-chart"></div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object
    },
    pending: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    pending () {
      this.drawChart()
    }
  },
  methods: {
    drawChart () {
      if (this.pending) {
        return
      }
      const myLineChar = this.$echarts.init(document.getElementById('line-chart'))
      myLineChar.setOption({
        // 图例,与下面的series的name对应
        legend: {
          data: ['风险等级:高', '风险等级:中', '风险等级:低']
        },
        xAxis: {
          data: this.data.xAxisData,
          boundaryGap: false, // 设置横坐标从原点开始
          axisTick: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: '#3C444F'
            }
          }
        },
        // y轴，不写自动会按series里面的数据进行显示
        yAxis: {
          axisTick: {
            show: true
          },
          axisLine: {
            lineStyle: {
              color: '#3C444F'
            }
          }
        },
        // 弹窗
        tooltip: {
          trigger: 'axis', // 从坐标轴出发
          axisPointer: {
            type: 'cross'
          },
          padding: [5, 10]
        },
        grid: { // 类似于绝对定位，用left等指定位置
          left: 10,
          right: 30,
          bottom: this.data.xAxisData.length > 10 ? 30 : 20,
          top: 30,
          show: true,
          containLabel: true
        },
        dataZoom: [
          {
            handleSize: '100%',
            height: '24',
            type: 'slider',
            show: this.data.xAxisData.length > 10,
            realtime: false,
            start: 0,
            end: this.data.xAxisData.length > 10 ? parseInt(10 / this.data.xAxisData.length * 100) : 100,
            bottom: 0
          }
        ],
        // 数据项
        series: [
          {
            name: '风险等级:高',
            type: 'line',
            itemStyle: {
              normal: {
                color: '#9049BF',
                lineStyle: {
                  color: '#9049BF',
                  width: 2
                }
              }
            },
            data: this.data.seriesData.high
          },
          {
            name: '风险等级:中',
            type: 'line',
            itemStyle: {
              normal: {
                color: '#FF8737',
                lineStyle: {
                  color: '#FF8737',
                  width: 2
                }
              }
            },
            data: this.data.seriesData.mid
          },
          {
            name: '风险等级:低',
            type: 'line',
            itemStyle: {
              normal: {
                color: '#1D7ADC',
                lineStyle: {
                  color: '#1D7ADC',
                  width: 2
                }
              }
            },
            data: this.data.seriesData.low
          }
        ]
      })
      myLineChar.resize()
    }
  },
  mounted () {
    this.drawChart()
    window.addEventListener('resize', this.drawChart)
    this.$once('hook:beforeDestroy', () => {
      window.removeEventListener('resize', this.drawChart)
    })
  }
}
</script>

<style lang="scss" scoped>
.line-chart-wrapper {
  height: 280px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 4px 8px 0px rgba(17, 39, 98, 0.04);
  border-radius: 4px;
  padding: 10px 0;
  box-sizing: border-box;
  #line-chart {
    width: 100%;
    height: 100%;
  }
}
</style>
